"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import TabPanel from 'devextreme-react/tab-panel';

var styles = function styles(theme) {
  return {
    d5FormCaption: {
      fontSize: 20,
      borderBottom: '1px solid #d5d9da',
      paddingBottom: 3,
      margin: '0 2px',
      flex: '0 0 auto'
    },
    d5FormContainer: {
      flex: '1 0 auto'
    },
    withCaption: {
      height: 'calc(100% - 41px)'
    },
    fullHeight: {
      height: '100%'
    },
    tabForm: {
      paddingTop: theme.spacing.unit
    }
  };
};

var D5FormLayoutTabsClass =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5FormLayoutTabsClass, _PureComponent);

  function D5FormLayoutTabsClass(props) {
    var _this;

    _classCallCheck(this, D5FormLayoutTabsClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5FormLayoutTabsClass).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "elements", []);

    _this.getItemTemplate = _this.getItemTemplate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(D5FormLayoutTabsClass, [{
    key: "getDataSource",
    value: function getDataSource() {
      var children = this.props.children;
      return (children || []).map(function (tab) {
        return {
          children: tab.props.children,
          title: tab.props.caption
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.elements.forEach(function (element) {
        ReactDOM.unmountComponentAtNode(element);
      });
    }
  }, {
    key: "getItemTemplate",
    value: function getItemTemplate(itemData, itemIndex, itemElement) {
      var classes = this.props.classes;
      ReactDOM.render(React.createElement("div", {
        className: classes.fullHeight
      }, itemData.children), itemElement);
      this.elements.push(itemElement);
      return itemElement;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          caption = _this$props.caption,
          classes = _this$props.classes;
      return React.createElement("div", {
        className: classes.fullHeight
      }, caption ? React.createElement("div", {
        className: classes.d5FormCaption
      }, caption) : null, React.createElement("div", {
        className: classNames(classes.d5FormContainer, !caption ? classes.fullHeight : classes.withCaption)
      }, React.createElement(TabPanel, {
        id: "tab-form-".concat(id),
        dataSource: this.getDataSource(),
        className: classNames(classes.fullHeight, classes.tabForm),
        deferRendering: false,
        itemTemplate: this.getItemTemplate
      })));
    }
  }]);

  return D5FormLayoutTabsClass;
}(PureComponent);

_defineProperty(D5FormLayoutTabsClass, "propTypes", {
  classes: PropTypes.object.isRequired,
  caption: PropTypes.string,
  direction: PropTypes.string,
  items: PropTypes.array
});

export default withStyles(styles)(D5FormLayoutTabsClass);